var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnDemand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.3,
    height: 97.6,
    viewBox: "0 0 94.3 97.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#7d9aa7}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2022150_app_car_service_ride_smartphone_taxi_icon",
    transform: "translate(-2.8 -1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    d: "M76.5 49.4a.746.746 0 0 0-.5-.6l-1.8.2-1.6-3.8a2.122 2.122 0 0 0-1.7-1.2h-2l-.7-1.2c-.1-.1-.2-.2-.3-.2h-3.4c-.1 0-.3.1-.3.2l-.7 1.2h-2.1a1.832 1.832 0 0 0-1.7 1.2L58.1 49l-1.7-.2a.746.746 0 0 0-.5.6c-.1.5-.2 1.3.8 1.6l.6.1c-.7 1.4-1.5 3.8.5 5.8a3.775 3.775 0 0 0 .8.5v1.2a.789.789 0 0 0 .8.8h1.1a.789.789 0 0 0 .8-.8v-1.1H71v1.1a.789.789 0 0 0 .8.8h1.1a.789.789 0 0 0 .8-.8v-1.2a2.177 2.177 0 0 0 .8-.5 4.949 4.949 0 0 0 .7-5.9h.5c1-.3.9-1.1.8-1.6zM61 45.7c0-.1.2-.3.6-.4h9.2a.5.5 0 0 1 .5.3l1.6 3.7H59.4zm-.7 8.4a1.2 1.2 0 1 1 1.2-1.2 1.155 1.155 0 0 1-1.2 1.2zm11.6 0a1.2 1.2 0 1 1 1.2-1.2 1.155 1.155 0 0 1-1.2 1.2z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_13_",
    cx: 3.3,
    cy: 3.3,
    r: 3.3,
    className: "cls-1",
    transform: "translate(45.3 87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M42.8 8.3a1.3 1.3 0 0 0 0 2.6h11.8a1.3 1.3 0 0 0 0-2.6z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    d: "M85.1 36.7h-9V9.5a8.237 8.237 0 0 0-8.2-8.2H29.4a8.237 8.237 0 0 0-8.2 8.2v81.2a8.237 8.237 0 0 0 8.2 8.2h38.5a8.237 8.237 0 0 0 8.2-8.2V65.5h9a3.441 3.441 0 0 0 3.3-3.5V40.2a3.441 3.441 0 0 0-3.3-3.5zM24.3 9.5a5.121 5.121 0 0 1 5.1-5.1h38.5A5.121 5.121 0 0 1 73 9.5v4.6H24.3zM73 90.7a5.121 5.121 0 0 1-5.1 5.1H29.4a5.121 5.121 0 0 1-5.1-5.1V85H73zm0-8.8H24.3V17.2H73v19.5H47.3a3.441 3.441 0 0 0-3.3 3.5V62a3.441 3.441 0 0 0 3.3 3.5h3.8l1.6 9.2 9-9.2H73zM85.6 62a.458.458 0 0 1-.5.4H60.7l-6.1 6.3-1.1-6.3h-6.1a.458.458 0 0 1-.5-.4V40.2a.458.458 0 0 1 .5-.4h37.8a.458.458 0 0 1 .5.4V62z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    d: "M96.2 29.1h-1.5v-1.5a.9.9 0 0 0-1.8 0v1.5h-1.5a.9.9 0 1 0 0 1.8h1.5v1.5a.9.9 0 0 0 1.8 0V31h1.5a.9.9 0 0 0 .9-.9.987.987 0 0 0-.9-1z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M15.3 67.7h-1.5v-1.5a.9.9 0 1 0-1.8 0v1.5h-1.5a.9.9 0 0 0 0 1.8H12V71a.9.9 0 1 0 1.8 0v-1.5h1.5a.9.9 0 0 0 0-1.8z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M13.3 19.2h-2.5v-2.5a1.3 1.3 0 0 0-2.6 0v2.5H5.6a1.3 1.3 0 1 0 0 2.6h2.5v2.5a1.3 1.3 0 0 0 2.6 0v-2.5h2.5a1.324 1.324 0 0 0 1.3-1.3c.2-.7-.4-1.3-1.2-1.3z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_3_",
    cx: 1.7,
    cy: 1.7,
    r: 1.7,
    className: "cls-1",
    transform: "translate(2.8 44.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_2_",
    cx: 1.7,
    cy: 1.7,
    r: 1.7,
    className: "cls-1",
    transform: "translate(85.5 81.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1_",
    cx: 2.2,
    cy: 2.2,
    r: 2.2,
    className: "cls-1",
    transform: "translate(83.5 14.1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnDemand);
export default __webpack_public_path__ + "static/media/onDemand.d5179455ee596ef001df575a2afc513e.svg";
export { ForwardRef as ReactComponent };